import auth, { IRespondToMfa } from '../services/auth';
import resolveChallenge from './resolveChallenge';

export default async (formData: IRespondToMfa) => {
    const res = await auth.respondToMfa(formData);
    resolveChallenge(res.data);
};
